// Array for the Host Options
export const hostOptionArray = [
  {
    lable: "Start Recording",
    state: false,
    ifInfo: false,
    isPreview: true,
    checked: false,
    isMain: false,
    name: "StartRecording",
    user: "host",
    isClassType: false,
    isAppointmentType: false,
  },
  {
    lable: "Allow Microphone for All",
    ifInfo: false,
    state: true,
    isPreview: true,
    isMain: true,
    checked: true,
    name: "EnableMic",
    user: "host",
    isClassType: true,
    isAppointmentType: true,
  },
  {
    lable: "Allow Video for All",
    ifInfo: false,
    state: true,
    isPreview: true,
    isMain: true,
    checked: true,
    name: "EnableVideo",
    user: "host",
    isClassType: true,
    isAppointmentType: true,
  },
  {
    lable: "Allow Chat for All",
    ifInfo: false,
    state: true,
    isPreview: true,
    isMain: true,
    checked: true,
    name: "EnableChat",
    user: "host",
    isClassType: true,
    isAppointmentType: true,
  },
  {
    lable: "Allow Screen Share for All",
    ifInfo: false,
    state: false,
    isPreview: true,
    checked: false,
    isMain: true,
    name: "EnableScreenShare",
    user: "host",
    isClassType: true,
    isAppointmentType: true,
  },
  {
    lable: "Instructor Only Mode",
    ifInfo: true,
    ifInfoMessage: "This cannot be changed during the live stream session.",
    state: false,
    message:"Attendees can view and hear the instructor, but not other attendees.",
    isPreview: true,
    isMain: false,
    checked: false,
    name: "InstructorMode",
    user: "host",
    isClassType: false,
    isAppointmentType: false,
  },
  {
    lable: "Fit Video to Frame",
    state: false,
    ifInfo: false,
    isPreview: true,
    checked: true,
    isMain: true,
    name: "FitToFrame",
    user: "both",
    isClassType: true,
    isAppointmentType: true,
    isMobileGear: true,
    isPreviewAttendeeApp: true
  },
];
